export const rendomContactDetailsMsg = [
  "Data Missing - We're On It!",
  'Your request, our mission!',
  'On the hunt!',
  'Your request is our quest!',
  'Data discovery underway!',
  'Your search is our adventure!',
]
